<!-- =========================================================================================
  File Name: BookView.vue
  Description: Book View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-book-view">

    <vs-alert color="danger" title="Book Not Found" :active.sync="book_not_found">
      <span>Book record with bookSeq: {{ $route.params.bookSeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'book-list'}" class="text-inherit underline">All Books</router-link>
      </span>
    </vs-alert>

    <div id="book-data" v-if="book_data">

      <vx-card title="교재 상세 정보" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="book-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">브랜드</td>
                <td>{{ book_data.brandName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">코스</td>
                <td>{{ book_data.courseName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">레벨</td>
                <td>{{ book_data.levelName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">교재명</td>
                <td>{{ book_data.bookName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">권</td>
                <td>{{ book_data.volumeNumber }}/{{ book_data.totalVolume }}</td>
              </tr>
              <tr>
                <td class="font-semibold">교재코드</td>
                <td>{{ book_data.bookCode }}</td>
              </tr>
              <tr>
                <td class="font-semibold">판매가</td>
                <td>{{ price }}</td>
              </tr>
              <tr>
                <td class="font-semibold">비고</td>
                <td>{{ book_data.remark  }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->
          <div class="vx-col w-full flex justify-end" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="ml-auto mt-2" :to="{name: 'book-edit', params: { bookSeq: $route.params.bookSeq }}">수정</vs-button>
            <!-- <vs-button class="ml-4 mt-2" color="success" :to="{name: 'book-contents', params: { bookSeq: $route.params.bookSeq }}">문제관리</vs-button> -->
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
            <!-- <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">삭제</vs-button> -->
          </div>
        </div>
      </vx-card>
      <!-- <vx-card>
        <div>
          <div class="vx-col w-full">
            <div class="mb-4 flex flex-wrap justify-between">
              <div class="justify-end">
                <vs-button class="" @click="onBookMetaInfo">메타정보 추가</vs-button>
              </div>
            </div>
          </div>

          <vue-good-table
            mode="remote"
            isLoading.sync="isLoading"
            @on-row-click="onRowClick"
            :columns="columns"
            :rows="rows"
            :fix-header="true"
            :line-numbers="false"
            styleClass="vgt-table condensed"
            />
        </div>
      </vx-card>   -->
    </div>
  </div>
</template>

<script>
import { fetchData, putData } from '@/api/module'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      bookSeq: 0,
      rows: [],
      book_data: null,
      book_not_found: false,
      totalRecords: 0,
      columns: [
        {
          label: 'No.',
          field: 'bookMetaSeq',
          type: 'name',
          sortable: false
        },
        {
          label: '데이타 타입',
          field: 'metaType',
          type: 'name',
          sortable: false,
          tdClass: this.tdClassStatus
        },
        {
          label: '데이타 코드',
          field: 'metaCode',
          type: 'name',
          sortable: false
        },
        {
          label: '데이타 값',
          field: 'metaValue',
          type: 'name',
          sortable: false
        },
        {
          label: '삭제유무',
          field: 'deleteYn',
          type: 'name',
          sortable: false,
          tdClass: this.tdClassDeleteYn
        }
      ]
    }
  },
  computed: {
    price () {
      const regexp = /\B(?=(\d{3})+(?!\d))/g
      return `${this.book_data.price.toString().replace(regexp, ',')  }원`
    }
  },
  methods: {

    onBookMetaInfo () {
      this.$router.push(`/book/bookmeta-add/${this.bookSeq}`)
    },
    tdClassStatus (row) {
      if (row.metaType === 'UNIT') {
        return 'text-danger'
      } else if (row.metaType === 'STEP') {
        return 'text-primary'
      } else if (row.metaType === 'MENU') {
        return 'text-success'
      }
    },
    tdClassDeleteYn (row) {
      if (row.deleteYn === 'Y') {
        return 'text-danger'
      } else {
        return 'text-primary'
      }
    },
    onRowClick (params) {

      const bookMetaSeq = params.row.bookMetaSeq
      this.$router.push(`/book/bookmeta-edit/${this.bookSeq}/${bookMetaSeq}`)
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '삭제 ',
        text: `"${this.book_data.bookName} (을/를) 삭제하시겠습니까?"`,
        accept: this.deleteRecord,
        acceptText: '삭제'
      })
    },
    async deleteRecord () {
      try {
        const bookData = {
          status: 1,
          bookSeq: this.book_data.bookSeq
        }
        const {data} = await putData('book/status', bookData)
        this.$vs.loading.close()
        console.log(data)
        this.$router.push('/book/book-list')
        // const bookSeq = this.book_data.bookSeq;
        // this.$router.push(`/book/book-view/${bookSeq}`);
        // this.$emit('refresh');
        this.showDeleteSuccess()

      } catch (error) {
        // console.log(error.response.data.msg);
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadBookMetaInfo () {
      try {
        const {data} = await fetchData(`/book-meta/${this.bookSeq}`)
        this.$vs.loading.close()
        this.rows = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadBook () {
      try {
        const { data } = await fetchData(`book/${this.bookSeq}`)
        this.book_data = data.data
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
    // showDeleteSuccess () {
    //   this.$vs.notify({
    //     color: 'success',
    //     title: '삭제',
    //     text: '삭제 되었습니다.'
    //   })
    // }
  },
  
  created () {
    this.bookSeq = this.$route.params.bookSeq
    this.loadBook()
    this.loadBookMetaInfo()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-book-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
